
import Hero from "../components/Hero";
import hotelImg from "../assests/images/hotel-bg.jpg";

import {
    FaFileContract,
    FaLock,
    FaUserCheck,
    FaCreditCard,
    FaCalendarAlt,
    FaInfoCircle,
    FaChevronRight,
    FaCheckCircle,
    FaArrowRight,
    FaExclamationTriangle,
    FaShieldAlt,
} from "react-icons/fa";

export default function TermsAndConditions() {
    const quickLinks = [
        "Introduction",
        "Bookings & Reservations",
        "Payments",
        "Cancellation & Refunds",
        "Guest Responsibilities",
        "Hotel Information",
        "Third-Party Services",
        "Contact Us",
    ];

    return (
        <div className="w-full bg-[#F5F8FA]">

            {/* HERO */}
            <Hero
                variant="inner"
                title="Terms & Conditions"
                subtitle="Please review the terms and conditions that apply when using our website and booking services."
                backgroundImage={hotelImg}
            />

            {/* INTRODUCTION */}
            <section className="relative overflow-hidden bg-[#F5F8FA] px-5 py-14 sm:px-8 sm:py-16 lg:px-12 lg:py-20 xl:px-16">

                <div className="pointer-events-none absolute -right-40 top-0 h-96 w-96 rounded-full bg-[#0B5552]/5 blur-3xl" />
                <div className="pointer-events-none absolute -left-40 bottom-0 h-96 w-96 rounded-full bg-[#D7A74A]/10 blur-3xl" />

                <div className="relative z-10 mx-auto max-w-[1440px]">

                    <div className="grid gap-7 lg:grid-cols-[1.35fr_0.65fr]">

                        {/* INTRO CARD */}
                        <div className="group relative overflow-hidden rounded-[28px] border border-[#E2E9E9] bg-white p-7 shadow-[0_15px_45px_rgba(23,63,62,0.05)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_22px_55px_rgba(23,63,62,0.10)] sm:p-9 lg:p-10">

                            <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-[#0B5552] to-[#D7A74A]" />

                            <div className="flex flex-col gap-5 sm:flex-row sm:items-start">

                                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#0B5552]/10 text-[#0B5552] transition-all duration-300 group-hover:bg-[#0B5552] group-hover:text-white">
                                    <FaFileContract className="text-xl" />
                                </div>

                                <div className="min-w-0">

                                    <div className="flex items-center gap-3">
                                        <span className="h-px w-7 bg-[#D7A74A]" />
                                        <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#0B5552]">
                                            Terms & Conditions
                                        </span>
                                    </div>

                                    <h2 className="mt-3 font-serif text-2xl leading-tight text-[#173F3E] sm:text-3xl lg:text-[34px]">
                                        Our Terms of Service
                                    </h2>

                                    <p className="mt-4 max-w-3xl text-sm leading-7 text-[#71808A] sm:text-base">
                                        These Terms & Conditions govern your
                                        use of our website and services,
                                        including hotel searches, reservations,
                                        bookings and related travel services.
                                        By using our website, you agree to
                                        follow these terms.
                                    </p>

                                </div>
                            </div>
                        </div>

                        {/* IMPORTANT INFORMATION */}
                        <div className="group relative overflow-hidden rounded-[28px] bg-gradient-to-br from-[#173F3E] to-[#0B5552] p-7 text-white shadow-[0_18px_50px_rgba(23,63,62,0.15)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_24px_55px_rgba(23,63,62,0.22)] sm:p-8">

                            <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-white/10 blur-2xl" />
                            <div className="pointer-events-none absolute -bottom-20 -left-20 h-48 w-48 rounded-full bg-[#D7A74A]/15 blur-3xl" />

                            <div className="relative z-10">

                                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#D7A74A] text-[#173F3E]">
                                    <FaLock />
                                </div>

                                <h3 className="mt-5 font-serif text-xl !text-white">
                                    Important Information
                                </h3>

                                <p className="mt-2 text-sm leading-6 text-white/70">
                                    Please review these terms carefully before
                                    making a booking or using our services.
                                </p>

                                <div className="mt-6 space-y-3.5">
                                    {[
                                        "Review booking details carefully",
                                        "Check hotel-specific policies",
                                        "Keep your booking information secure",
                                    ].map((item, index) => (
                                        <div key={index} className="flex items-center gap-3">
                                            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/10">
                                                <FaCheckCircle className="text-[10px] text-[#D7A74A]" />
                                            </span>

                                            <span className="text-xs text-white/80">
                                                {item}
                                            </span>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* TERMS CONTENT */}
            <section className="bg-[#F5F8FA] px-5 pb-16 sm:px-8 sm:pb-20 lg:px-12 lg:pb-24 xl:px-16">

                <div className="mx-auto max-w-[1440px]">

                    <div className="grid gap-8 lg:grid-cols-[260px_1fr]">

                        {/* DESKTOP SIDEBAR */}
                        <aside className="hidden lg:block">
                            <div className="sticky top-24 rounded-[24px] border border-[#E2E9E9] bg-white p-5 shadow-[0_10px_35px_rgba(23,63,62,0.05)]">

                                <div className="mb-5">
                                    <div className="flex items-center gap-2">
                                        <span className="h-px w-6 bg-[#D7A74A]" />
                                        <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#0B5552]">
                                            On This Page
                                        </p>
                                    </div>

                                    <h3 className="mt-2 font-serif text-lg text-[#173F3E]">
                                        Quick Navigation
                                    </h3>
                                </div>

                                <div className="space-y-1">
                                    {quickLinks.map((item, index) => (
                                        <a
                                            key={index}
                                            href={`#section-${index}`}
                                            className="group flex items-center gap-3 rounded-xl px-3 py-2.5 text-xs font-semibold text-[#71808A] transition-all duration-300 hover:translate-x-1 hover:bg-[#F0F6F5] hover:text-[#0B5552]"
                                        >
                                            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-lg bg-[#0B5552]/10 text-[9px] font-bold text-[#0B5552] transition-all duration-300 group-hover:bg-[#0B5552] group-hover:text-white">
                                                {String(index + 1).padStart(2, "0")}
                                            </span>

                                            <span className="flex-1">{item}</span>

                                            <FaChevronRight className="text-[8px] opacity-0 transition-all duration-300 group-hover:translate-x-0.5 group-hover:opacity-100" />
                                        </a>
                                    ))}
                                </div>

                            </div>
                        </aside>

                        {/* MAIN CONTENT */}
                        <div>

                            {/* MOBILE NAVIGATION */}
                            <div className="mb-6 lg:hidden">
                                <details className="group overflow-hidden rounded-2xl border border-[#E2E9E9] bg-white shadow-[0_8px_25px_rgba(23,63,62,0.04)]">

                                    <summary className="flex cursor-pointer list-none items-center justify-between px-5 py-4 text-sm font-bold text-[#173F3E]">
                                        <span>Terms & Conditions Sections</span>

                                        <FaChevronRight className="text-xs text-[#0B5552] transition-transform duration-300 group-open:rotate-90" />
                                    </summary>

                                    <div className="border-t border-[#E2E9E9] p-3">
                                        <div className="grid grid-cols-1 gap-1 sm:grid-cols-2">
                                            {quickLinks.map((item, index) => (
                                                <a
                                                    key={index}
                                                    href={`#section-${index}`}
                                                    className="group flex items-center gap-3 rounded-xl px-3 py-3 text-xs font-semibold text-[#71808A] transition-all duration-300 hover:bg-[#F0F6F5] hover:text-[#0B5552]"
                                                >
                                                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#0B5552]/10 text-[9px] font-bold text-[#0B5552] group-hover:bg-[#0B5552] group-hover:text-white">
                                                        {String(index + 1).padStart(2, "0")}
                                                    </span>

                                                    {item}
                                                </a>
                                            ))}
                                        </div>
                                    </div>

                                </details>
                            </div>

                            {/* TERMS CARD */}
                            <div className="overflow-hidden rounded-[28px] border border-[#E2E9E9] bg-white shadow-[0_15px_50px_rgba(23,63,62,0.05)]">

                                <div className="h-1 w-full bg-gradient-to-r from-[#173F3E] via-[#0B5552] to-[#D7A74A]" />

                                <div className="p-6 sm:p-8 lg:p-10 xl:p-12">

                                    <div className="space-y-0">

                                        <Section
                                            id="section-0"
                                            number="01"
                                            icon={<FaInfoCircle />}
                                            title="Introduction"
                                            text="These Terms & Conditions apply to your use of our website and services. By accessing our website, searching for hotels, making a reservation or using any of our services, you acknowledge that you have read and understood these terms."
                                        />

                                        <Section
                                            id="section-1"
                                            number="02"
                                            icon={<FaCalendarAlt />}
                                            title="Bookings & Reservations"
                                            list={[
                                                "All bookings are subject to availability and confirmation.",
                                                "You are responsible for providing accurate guest and booking information.",
                                                "Please review your hotel, room type, dates, guest details and booking conditions before confirming.",
                                                "A booking is considered confirmed only after the applicable confirmation has been issued.",
                                            ]}
                                        />

                                        <Section
                                            id="section-2"
                                            number="03"
                                            icon={<FaCreditCard />}
                                            title="Payments"
                                            list={[
                                                "Payment requirements may vary depending on the hotel, room type and booking conditions.",
                                                "You agree to provide accurate payment information when required.",
                                                "Some bookings may require full payment, a deposit or payment at the property.",
                                                "Additional hotel charges, taxes, deposits or service fees may apply where stated during the booking process.",
                                            ]}
                                        />

                                        <Section
                                            id="section-3"
                                            number="04"
                                            icon={<FaCalendarAlt />}
                                            title="Cancellation & Refunds"
                                            text="Cancellation and refund conditions depend on the specific hotel and booking selected. Some rates may be refundable while others may be non-refundable. You should carefully review the cancellation policy shown with your booking before confirming. Any applicable refund will be handled according to the relevant booking terms."
                                        />

                                        <Section
                                            id="section-4"
                                            number="05"
                                            icon={<FaUserCheck />}
                                            title="Guest Responsibilities"
                                            list={[
                                                "Provide accurate and complete information when making a booking.",
                                                "Present valid identification and required documents when requested by the hotel or service provider.",
                                                "Follow the hotel's rules, policies and applicable local regulations.",
                                                "Use the website and services lawfully and responsibly.",
                                                "You are responsible for any charges resulting from misuse, damage or violation of applicable hotel policies.",
                                            ]}
                                        />

                                        <Section
                                            id="section-5"
                                            number="06"
                                            icon={<FaInfoCircle />}
                                            title="Hotel Information"
                                            text="Hotel descriptions, photographs, facilities, room information, ratings and other details are provided for informational and booking purposes. Hotel facilities, policies, room features and availability may change. Specific hotel policies may also differ depending on the property, room type and rate selected."
                                        />

                                        <Section
                                            id="section-6"
                                            number="07"
                                            icon={<FaShieldAlt />}
                                            title="Third-Party Services"
                                            text="Our website may provide access to or information about services offered by third parties, including hotels, travel providers, payment providers and other service partners. Third-party services may have their own terms, policies and conditions. We recommend reviewing those terms before using the relevant service."
                                        />

                                        <Section
                                            id="section-7"
                                            number="08"
                                            icon={<FaInfoCircle />}
                                            title="Contact Us"
                                            text="If you have questions about these Terms & Conditions, your booking or any of our services, please contact our support team. We will be happy to assist you with your enquiry."
                                            last
                                        />

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* IMPORTANT NOTICE */}
            <section className="bg-[#F5F8FA] px-5 pb-16 sm:px-8 sm:pb-20 lg:px-12 lg:pb-24 xl:px-16">

                <div className="mx-auto max-w-[1440px]">

                    <div className="group relative overflow-hidden rounded-[30px] bg-gradient-to-br from-[#173F3E] to-[#0B5552] px-6 py-11 text-center shadow-[0_20px_60px_rgba(23,63,62,0.15)] sm:px-10 sm:py-14">

                        <div className="pointer-events-none absolute -left-24 -top-24 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
                        <div className="pointer-events-none absolute -bottom-24 -right-24 h-64 w-64 rounded-full bg-[#D7A74A]/15 blur-3xl" />
                        <div className="pointer-events-none absolute left-1/2 top-0 h-40 w-40 -translate-x-1/2 rounded-full bg-white/5 blur-3xl" />

                        <div className="relative z-10 mx-auto max-w-2xl">

                            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#D7A74A] text-xl text-[#173F3E] shadow-lg transition-transform duration-500 group-hover:rotate-6 group-hover:scale-110">
                                <FaExclamationTriangle />
                            </div>

                            <div className="mt-6 flex items-center justify-center gap-3">
                                <span className="h-px w-7 bg-[#D7A74A]" />
                                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#D7A74A]">
                                    Before You Book
                                </span>
                                <span className="h-px w-7 bg-[#D7A74A]" />
                            </div>

                            <h2 className="mt-4 font-serif text-2xl leading-tight !text-white sm:text-3xl lg:text-[36px]">
                                Please Review Your Booking Carefully
                            </h2>

                            <p className="mt-4 text-sm leading-7 text-white/70 sm:text-base">
                                Hotel rates, cancellation conditions, payment
                                requirements and property policies may vary.
                                Please review the details of your selected
                                booking before confirming your reservation.
                            </p>

                            <a
                                href="/contact-us"
                                className="group/btn mt-8 inline-flex items-center gap-3 rounded-full bg-[#D7A74A] px-6 py-3.5 text-sm font-bold text-[#173F3E] shadow-lg transition-all duration-300 hover:-translate-y-1 hover:bg-[#E8C879] hover:shadow-xl"
                            >
                                Contact Our Team

                                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#173F3E] text-[#D7A74A] transition-transform duration-300 group-hover/btn:translate-x-1">
                                    <FaArrowRight className="text-[10px]" />
                                </span>
                            </a>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

/* REUSABLE TERMS SECTION */
function Section({
    id,
    number,
    icon,
    title,
    text,
    list,
    last = false,
}) {
    return (
        <div
            id={id}
            className={`scroll-mt-28 ${!last
                ? "mb-9 border-b border-[#E5EBEB] pb-9"
                : ""
                }`}
        >

            <div className="flex items-start gap-4 sm:gap-5">

                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#0B5552]/10 text-xs font-bold text-[#0B5552]">
                    {number}
                </div>

                <div className="min-w-0 flex-1">

                    <div className="flex items-center gap-2.5">
                        <span className="text-sm text-[#D7A74A]">
                            {icon}
                        </span>

                        <h2 className="font-serif text-xl leading-tight text-[#173F3E] sm:text-[23px]">
                            {title}
                        </h2>
                    </div>

                    {text && (
                        <p className="mt-4 text-sm leading-7 text-[#71808A] sm:text-[15px]">
                            {text}
                        </p>
                    )}

                    {list && (
                        <div className="mt-5 space-y-3">
                            {list.map((item, index) => (
                                <div
                                    key={index}
                                    className="group flex items-start gap-3"
                                >
                                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#0B5552]/10 transition-colors duration-300 group-hover:bg-[#0B5552]">
                                        <FaCheckCircle className="text-[8px] text-[#0B5552] transition-colors duration-300 group-hover:text-white" />
                                    </span>

                                    <p className="text-sm leading-6 text-[#71808A] sm:text-[15px]">
                                        {item}
                                    </p>
                                </div>
                            ))}
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}